import React, { useCallback, useEffect, useState ,KeyboardEvent} from 'react';
import { useNavigate } from 'react-router-dom';
import {
  Button,
  Card,
  CardContent,
  CardHeader,
  IconButton,
  ListItemIcon,
  ListItemText,
  Menu,
  MenuItem,
  Pagination,
  Paper,
  Select,
  SelectChangeEvent,
  Stack,
  styled,
  Table,
  TableBody,
  TableCell,
  tableCellClasses,
  TableContainer,
  TableHead,
  TableRow,
  Typography,
} from '@mui/material';
import MoreVertIcon from '@mui/icons-material/MoreVert';
import AttachFileIcon from '@mui/icons-material/AttachFile';
import dateformat from 'dateformat';

import { T_Inquery } from '../../common/model/InqueryModel';
import { T_File } from '../../common/model/fileModel';
import { T_Page } from '../../common/model/apiModel';
import { useProgress } from '../../contexts/ProgressContextProvider';
import apis from '../../common/apis';
import values from '../../common/values';
import { initialAlert, useAlert } from '../../provider/AlertContextProvider';
import { Search, SearchIconWrapper, StyledInputBase, StyledTableCell } from '../../common/style/styles';
import SearchIcon from '@mui/icons-material/Search';
import { useAppState } from '../../contexts/appState';
// 상태 매핑
const inqueryStatusMap: Record<string, string> = {
  '0': '접수대기',
  '1': '접수완료',
  '2': '처리중',
  '3': '처리완료',
  '4': '취소',
};

export default function InqueryList() {
  const navigate = useNavigate();
  const pageSize = 10;
  
  // 페이지 및 리스트 상태
  const [page, setPage] = useState(1);
  const [list, setList] = useState<T_Inquery[] | null>(null);
  const [pageInfo, setPageInfo] = useState<T_Page>();
  const { showProgress, setShowProgress } = useProgress();
  const {alert,setAlert} = useAlert();
const [selStatus,setSelStatus] = useState("all");
 const [skeyword,setSkeyword]=useState("");

 const appState = useAppState()
  // 페이지 변경 핸들러
  const handleChange = (_: React.ChangeEvent<unknown>, value: number) => {
    setPage(value);
  };

  const deleteInquery = async(idx:number)=>{

             setAlert({...alert,visible:true,msg:"정말로 삭제 하시겠습니까?",buttonList:[{text:"예",variant:"contained",onPress:async()=>{
      
                const result = await apis.inquery.inqueryDelete({idx:idx});
                console.log(result)
                if(result.code=="1"){
                    setAlert(initialAlert);
                    setAlert({...alert,msg:"정상적으로 삭제되었습니다."})
                    getList();
                }else{
                    setAlert(initialAlert);
                    setAlert({...alert,msg:"삭제중 오류가 발생하였습니다다."})
                }
                
        }}
        ,{text:"아니요",variant:"outlined",onPress:()=>{
            setAlert({...alert,visible:false});

        }}
    ]})
  }

  // 리스트 조회
  const getList = useCallback(async () => {
    try {
      setShowProgress(true);
       console.log("inquery list app:",appState)
      const result = await apis.inquery.inqueryList({ page, pagesize: pageSize,status:selStatus,skeyword:skeyword });
      console.log("result:",result)
      if (result.code === '1') {
        setList(result.data.list);
        setPageInfo(result.data);
      }
    } catch (err) {
      console.error(err);
    } finally {
      setShowProgress(false);
    }
  }, [page,selStatus,skeyword]);

  useEffect(() => {
     console.log("Inquery list app")
       getList();
  }, [page,selStatus]);

  
   function onKeyDown(e: KeyboardEvent<HTMLTextAreaElement | HTMLInputElement>) {
      if (e.key === 'Enter') {
        e.preventDefault(); // form 리프레시 방지
          getList()
      }
    }

  // 행 단위 메뉴 상태
  const [anchorEl, setAnchorEl] = useState<null | HTMLElement>(null);
  const [menuRow, setMenuRow] = useState<number | null>(null);
  const menuOpen = Boolean(anchorEl);
  const handleRowMenuClick = (e: React.MouseEvent<HTMLElement>, idx: number) => {
    setAnchorEl(e.currentTarget);
    setMenuRow(idx);
  };
  const handleRowMenuClose = () => {
    setAnchorEl(null);
    setMenuRow(null);
  };

  // 파일 메뉴 상태
  const [anchorElFile, setAnchorElFile] = useState<null | HTMLElement>(null);
  const [fileMenuRow, setFileMenuRow] = useState<number | null>(null);
  const handleFileIconClick = (e: React.MouseEvent<HTMLElement>, row: number) => {
    setAnchorElFile(e.currentTarget);
    setFileMenuRow(row);
  };
  const handleFileMenuClose = () => {
    setAnchorElFile(null);
    setFileMenuRow(null);
  };

  // 파일 다운로드
  const handleDownload = (file: T_File) => {
    const link = document.createElement('a');
    link.href = values.server.url+"/upload/"+ file.fileUrl;
   file.fileOrgNm &&  link.setAttribute('download', file.fileOrgNm);
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
    handleFileMenuClose();
  };

  return (
    <Card sx={{ width: '100%' }}>
      <CardHeader
        sx={{ pr: 5, pb: 0, mb: 0 }}
        title="고객문의"
        
        action={
          <Stack   direction="row"
                justifyContent="space-between"  // ← 여기만 바꿔주세요
                spacing={2}                     // 아이템 사이 약간의 간격
                sx={{ pt: 5, width: '100%' }}   // 전체 너비 확보
                >

                  <Search>
                      <SearchIconWrapper onClick={() => setPage(1)}>
                        <SearchIcon />
                      </SearchIconWrapper>
                      <StyledInputBase
                        placeholder="Search…"
                        inputProps={{ 'aria-label': 'search' }}
                        value={skeyword}
                        onChange={(e) => {
                          setSkeyword(e.target.value);
                        }
                      }
                        onKeyDown={onKeyDown}
                      />
                    </Search>                  
          <Select
            value={selStatus}
            size="small"
            onChange={(event:SelectChangeEvent)=>{
              setSelStatus(event.target.value)
            }}
          >
            <MenuItem value="all">전체</MenuItem>
            <MenuItem value={0}>접수대기</MenuItem>
            <MenuItem value={1}>접수</MenuItem>
            <MenuItem value={2}>처리대기</MenuItem>
            <MenuItem value={3}>처리완료</MenuItem>
            <MenuItem value={4}>처리취소</MenuItem>          
          </Select>
         
          <Button variant="outlined" onClick={() => navigate('/inquery/insert') }>
            등록
          </Button>
          </Stack>
        }
      />
      <CardContent>
        <TableContainer component={Paper}>
          <Table aria-label="simple table">
            <TableHead>
              <TableRow>
                <StyledTableCell align="center" sx={{ width: 180 }}>접수일시</StyledTableCell>
                <StyledTableCell align="left" sx={{ width: '20%' }}>제목</StyledTableCell>
                <StyledTableCell align="left">내용</StyledTableCell>
                <StyledTableCell align="left" sx={{ width: '15%' }}>담당자</StyledTableCell>
                <StyledTableCell align="center" sx={{ width: '10%' }}>상태</StyledTableCell>
                <StyledTableCell align="center" sx={{ width: '10%' }}>파일</StyledTableCell>
                <StyledTableCell align="center" sx={{ width: '10%' }}>비고</StyledTableCell>
              </TableRow>
            </TableHead>
            <TableBody>
              {list?.map((item, index) => (
                <TableRow key={index} hover>
                  <TableCell align="center">
                    {dateformat(item.insDate, 'yyyy-mm-dd HH:MM:ss')}
                  </TableCell>
                  <TableCell align="left">{item.title}</TableCell>
                  <TableCell align="left">{item.contents}</TableCell>
                  <TableCell align="left">—</TableCell>
                  <TableCell align="center">
                    {inqueryStatusMap[String(item.status)] ?? '알 수 없음'}
                  </TableCell>

                  {/* 파일 셀 */}
                  <TableCell align="center">
                    {item.files && item.files.length > 0 ? (
                      <>
                        <IconButton
                          size="small"
                          onClick={(e) => handleFileIconClick(e, index)}
                        >
                          <AttachFileIcon />
                        </IconButton>
                        <Menu
                          anchorEl={anchorElFile}
                          open={fileMenuRow === index}
                          onClose={handleFileMenuClose}
                          anchorOrigin={{ vertical: 'bottom', horizontal: 'center' }}
                          transformOrigin={{ vertical: 'top', horizontal: 'center' }}
                        >
                          {item.files.map((file, idx2) => (
                            <MenuItem key={idx2} onClick={() => handleDownload(file)}>
                              <ListItemIcon>
                                <AttachFileIcon fontSize="small" />
                              </ListItemIcon>
                              <ListItemText>{file.fileOrgNm}</ListItemText>
                            </MenuItem>
                          ))}
                        </Menu>
                      </>
                    ) : (
                      '—'
                    )}
                  </TableCell>

                  {/* 비고 셀(수정/삭제) */}
                  <TableCell align="center">
                    <IconButton
                      aria-label="menu"
                      onClick={(e) => handleRowMenuClick(e, index)}
                    >
                      <MoreVertIcon />
                    </IconButton>
                    <Menu
                      anchorEl={anchorEl}
                      open={menuRow === index}
                      onClose={handleRowMenuClose}
                      anchorOrigin={{ vertical: 'bottom', horizontal: 'right' }}
                      transformOrigin={{ vertical: 'top', horizontal: 'right' }}
                    >
                      <MenuItem
                        onClick={() => {
                          handleRowMenuClose();
                          navigate('/inquery/edit', { state: { item } });
                        }}
                      >
                        수정
                      </MenuItem>
                      <MenuItem
                        onClick={async () => {
                          handleRowMenuClose();
                          // TODO: 삭제 로직
                         item.idx &&  deleteInquery(item.idx);
                        }}
                      >
                        삭제
                      </MenuItem>
                    </Menu>
                  </TableCell>
                </TableRow>
              ))}
            </TableBody>
          </Table>
        </TableContainer>

        <Stack
          direction="row"
          justifyContent="center"
          alignItems="center"
          sx={{ pt: 5 }}
        >
          <Pagination
            count={pageInfo?.pages || 1}
            showFirstButton
            showLastButton
            boundaryCount={2}
            page={page}
            onChange={handleChange}
          />
        </Stack>
      </CardContent>
    </Card>
  );
}
